<template>
    <a-modal
      :title="title"
      :width="width"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
    >
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-form-item v-if="false" label="班级" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['deptId', validatorRules.deptId]" placeholder="请输入班级"></a-input>
          </a-form-item>
          <a-form-item v-if="false" label="课程" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['courseId', validatorRules.courseId]" placeholder="请输入课程"></a-input>
          </a-form-item>
          <a-form-item label="开课方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group v-decorator="['openMethod', { initialValue: 1 }]" @change="onOpenMehtodChange">
              <a-radio :value="2">定时开课</a-radio>
              <a-radio :value="1">手动开课</a-radio>
              <a-radio :value="0">不开课</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="开课时间" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="model.openMethod == 2">
            <j-date
              placeholder="请选择课程开课时间"
              v-decorator="['openTime', validatorRules.openTime]"
              :dateFormat="'YYYY-MM-DD HH:mm:ss'"
              :showTime="true"
              :trigger-change="true"
              style="width: 100%"
            />
          </a-form-item>
          <a-divider>单元开课时间</a-divider>
          <div class="unit-time-setting">
            <a-form-item v-for="u in units" :key="u.id" :label="u.unitName" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <span v-show="model.openMethod == 0">不开课</span>
              <div v-show="model.openMethod == 1">
                <a-row>
                  <a-col :span="6">
                    <a-radio-group v-model="u.isUnitOpen">
                      <a-radio :value="0" >未开课</a-radio>
                      <a-radio :value="1">开课</a-radio>
                    </a-radio-group>
                  </a-col>
                  <a-col :span="6">
                    <a-radio-group v-model="u.isVideoOpen">
                      <a-radio :value="0">不开放视频</a-radio>
                      <a-radio :value="1">开放视频</a-radio>
                    </a-radio-group>
                  </a-col>
                  <a-col :span="6">
                    <a-radio-group v-model="u.isWorkOpen">
                      <a-radio :value="0">不开放作业</a-radio>
                      <a-radio :value="1">开放作业</a-radio>
                    </a-radio-group>
                  </a-col>
                  <a-col :span="6">
                    <a-radio-group v-model="u.isWorkCaseOpen">
                      <a-radio :value="0">不开放练习</a-radio>
                      <a-radio :value="1">开放练习</a-radio>
                    </a-radio-group>
                  </a-col>
                </a-row>
              </div>
              <j-date
                v-show="model.openMethod == 2"
                placeholder="请选择单元开课时间"
                :dateFormat="'YYYY-MM-DD HH:mm:ss'"
                :showTime="true"
                :trigger-change="true"
                style="width: 100%"
                v-model="u.openTime"
              />
            </a-form-item>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </template>
  
  <script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  
  export default {
    name: 'TeachingCourseScheduleModal',
    components: {
      JDate,
    },
    data() {
      return {
        form: this.$form.createForm(this),
        title: '操作',
        width: 800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          deptId: { rules: [{ required: true, message: '请输入班级!' }] },
          courseId: { rules: [{ required: true, message: '请输入课程!' }] },
          openTime: { rules: [] },
        },
        url: {
          add: '/teaching/teachingCourseDept/add',
          edit: '/teaching/teachingCourseDept/edit',
        },
        departId: '',
        units: [],
      }
    },
    created() {},
    methods: {
      getDepartUnit(deptId, courseId) {
        getAction('/teaching/teachingCourseUnit/getDepartUnitSchedule?departId=' + deptId + '&courseId=' + courseId).then(
          (res) => {
            if (res.success) {
              this.units = res.result
              if (this.units == null || this.units.length == 0) {
                this.$message.warning('该班级没有单元')
              }
            }
            console.log(res)
          }
        )
      },
      openAllCourse(){
  
      },
      closeAllCourse(){
  
      },
      add() {
        this.edit({})
      },
      edit(record) {
        this.departId = record.deptId
        this.getDepartUnit(record.deptId, record.courseId)
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'deptId', 'courseId', 'openTime','openMethod'))
        })
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        that.confirmLoading = true
        this.units.map((unit) => {
          unit.departId = that.departId
        })
        //若为手动开课，将开课方式设为自动开课
        if (this.model.openMethod == 2) {
          this.units.map((u) => {
            u.isUnitOpen = 2
          })
        }
        httpAction('teaching/teachingCourseUnit/setUnitsOpenTime', this.units, 'put')
          .then((res) => {
            if (res.success) {
              that.$message.success('排课成功')
              //that.$message.success(res.message);
              // that.$emit('ok');
            } else {
              that.$message.warning(res.message)
            }
          })
          .finally(() => {
            that.confirmLoading = false
          })
        this.form.validateFields((err, values) => {
          let formData = Object.assign(this.model, values)
          httpAction(this.url.edit, formData, 'put')
            .then((res) => {
              if (res.success) {
                //that.$message.success(res.message);
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {})
        })
      },
      handleCancel() {
        this.close()
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'deptId', 'courseId', 'openTime', 'openMethod'))
      },
      onOpenMehtodChange(e) {
        this.model.openMethod = e.target.value
      },
    },
  }
  </script>
  <style lang="less" scoped>
  .unit-time-setting {
    height: 500px;
    overflow: scroll;
  }
  </style>